







































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { get } from 'lodash';
import ConflictModal from './conflictModal.vue';

@Component({
    components: {
        ConflictModal
    }
})
export default class BindRg extends Vue {
    @Prop()
    show: boolean;

    visible: boolean = false;
    searchLoading: boolean = false;
    options: any = [];
    ruleCustom: any = {};
    showConflictModal: boolean = false;
    transferParams: any = {
        categoryIds: []
    };
    conflictList: any[] = [];
    unConflictList: any[] = [];
    formCustom: any = {
        categoryIds: [],
        includeRg: false
    };

    @Watch('show')
    showHandler(val) {
        this.visible = val;
    }

    created() {
        this.getCatalogList();
    }

    converseFetchDataToCascader(list) {
        const res = list.map(item => {
            const temp = { ...item };
            temp.name = item.itemName || item.typeName || item.categoryName;
            temp.id = item.itemId || item.typeId || item.categoryId;
            if (item.children && item.children.length) {
                temp.children = this.converseFetchDataToCascader(item.children);
            }
            return temp;
        });
        return res;
    }

    async getCatalogList() {
        const spaceId = parseInt(this.$route.params.id, 10);
        const res = await api.ctiApi.otherCatalog({
            spaceId
        });
        this.options = this.converseFetchDataToCascader(get(res, ['data', 'items'], []));
    }

    closeModalHandler() {
        this.showConflictModal = !this.showConflictModal;
    }

    closeModal() {
        this.$emit('clodeModal');
    }

    async confirmIgnoreConflictHandler(params) {
        const res = await api.ctiApi.migrateSpace({
            ...params,
            unbindConflictingDirectories: true
        });
        if (get(res, ['code'], null) === 200) {
            this.$mtd.message.success('目录绑定成功');
            this.$emit('update');
        }
    }

    async confirm() {
        const categoryIds = this.formCustom.categoryIds.flat();
        const params = Object.assign({}, this.formCustom, {
            targetSpaceId: this.$route.params.id,
            categoryIds
        });
        const res = await api.ctiApi.migrateSpace(params);
        const conflict = get(res, ['data', 'conflict'], false);
        const noConflictingDirectories = get(res, ['data', 'noConflictingDirectories'], []);
        const conflictingDirectories = get(res, ['data', 'conflictingDirectories'], []);
        this.transferParams = params;
        this.conflictList = conflictingDirectories;
        this.unConflictList = noConflictingDirectories;
        if (conflict) {
            this.showConflictModal = true;
        } else {
            this.$mtd.message.success('绑定的目录处于停用状态，进入目录管理设置目录');
            this.$emit('update');
        }
        this.formCustom.categoryIds = [];
        this.formCustom.includeRg = false;
        this.getCatalogList();
        this.closeModal();
    }
}
